import React from 'react';
import PropTypes from 'prop-types';
import { cx } from './classNames';

// MUI CircularProgress draws on a 44px circle.
const CIRCLE = 44;

/**
 * An indeterminate progress spinner (MUI's CircularProgress): an arc that
 * grows, shrinks and turns, in the current text colour (give it a text
 * colour class for another). `size` is its width and height in px;
 * `thickness` its stroke in units of the 44px circle, as MUI's. It is a
 * role="progressbar" without a value; pass aria-hidden when nearby text
 * already says what is loading. Other props go to the root <span>.
 */
export default function Spinner({ size = 40, thickness = 3.6, className, style, ...spanProps }) {
    return (
        <span
            role="progressbar"
            className={cx('inline-block shrink-0 animate-progress-spin', className)}
            style={{ width: size, height: size, ...style }}
            {...spanProps}
        >
            <svg
                className="block"
                viewBox={`${CIRCLE / 2} ${CIRCLE / 2} ${CIRCLE} ${CIRCLE}`}
                aria-hidden="true"
                focusable="false"
            >
                <circle
                    className="animate-progress-dash"
                    cx={CIRCLE}
                    cy={CIRCLE}
                    r={(CIRCLE - thickness) / 2}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={thickness}
                    strokeDasharray="80px, 200px"
                    strokeDashoffset="0"
                />
            </svg>
        </span>
    );
}

Spinner.propTypes = {
    size: PropTypes.number,
    thickness: PropTypes.number,
    className: PropTypes.string,
    style: PropTypes.object,
};
